<template>
  <Observer
    tag="li"
    class="img-con1"
    @show="$parent.$emit('show', game, index)"
    @hover="$parent.$emit('hover', game, index)"
  >
    <a href="javascript:;" class="link1">
      <img :src="game.img_url" />
      <em v-if="game.hot_name" :class="getHotClass(game)">{{
        game.hot_name
      }}</em>
    </a>
    <div class="imglist-tit">
      <p class="">{{ game.title }}</p>
      <div class="imglist-f">
        <div class="l">
          <a
            :href="`/game-offical/${game.game_id}/`"
            target="_blank"
            @click="
              $parent.$emit('click-game', 'official website', game, index)
              clickStat('GW', '官网')
            "
            >官网</a
          >
          <span>|</span>
          <a
            :href="`/game-offical/${game.game_id}/gift`"
            target="_blank"
            @click="
              $parent.$emit('click-game', 'gift', game, index)
              clickStat('LB', '礼包')
            "
            >礼包</a
          >
        </div>
        <div class="r">
          <a
            href="javascript:;"
            class="join-btn"
            @click="
              $parent.$emit('click-game', 'enter', game, index)
              gameStat(game, 'JRYX', '进入游戏')
            "
            >进入游戏</a
          >
        </div>
      </div>
    </div>
  </Observer>
</template>

<script>
export default {
  props: {
    game: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    statParams: {
      type: Object,
      required: false
    }
  },
  methods: {
    getHotClass({ hot_name }) {
      return {
        'min-tab': true,
        'hot-tab': hot_name === 'hot',
        'new-tab': hot_name === 'new'
      }
    },
    clickStat(eid, eid_desc) {
      if (!this.statParams) {
        return
      }
      this.$util.clickStat(
        `${this.statParams.eid}${this.index + 1}/${eid}`,
        `${this.statParams.eid_desc}${this.index + 1}/${eid_desc}`
      )
    },
    async gameStat(game, eid, eid_desc) {
      if (!this.statParams) {
        this.$util.playGame(game)
        return
      }
      const { game_id, new_server_id = 0 } = game
      let { server_id = 0 } = game
      if (new_server_id) {
        server_id = new_server_id
      }
      if (!server_id) {
        await this.$request(
          'getNewServer',
          {
            body: {
              game_id
            }
          },
          { errPage: false }
        ).then((data = {}) => (server_id = data || 0))
      }
      if (this.statParams.type && this.statParams.type === 'allgame') {
        this.$parent.$emit('click-stat', game_id, server_id, this.index + 1)
        return
      }
      this.$util.gameStat(
        game_id,
        server_id,
        `${this.statParams.eid}${this.index + 1}/${eid}`,
        `${this.statParams.eid_desc}${this.index + 1}/${eid_desc}`
      )
    }
  }
}
</script>
